import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";

const WrapperLegal = ({ title, text }) => {
  return (
    <Wrapper>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1>{title}</h1>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-7">
            <div
              className="scrollbar"
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
          </div>
          <div className="col-md-5">
            <StaticImage
              className="img-fluid px-5 px-md-0"
              src="../assets/images/contract.png"
              alt="contract"
            />
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default WrapperLegal;

const Wrapper = styled.section`
  background: #132779c2;
  padding: 50px 0;
  h1 {
    color: #fff;
    font-weight: 600;
    margin-bottom: 30px;
  }

  .scrollbar {
    background: #f0f0f0;
    padding: 30px 35px;
    height: 400px;
    overflow-y: scroll;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5;
      border-radius: 8px;
    }
    &::-webkit-scrollbar {
      width: 8px;
      background-color: #f5f5f5;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background-color: #5268c2;
    }

    p {
      color: #5268c2;
      font-size: 14px;
    }
  }

  @media (max-width: 767px) {
    padding: 30px 0;
    h1 {
      font-size: 24px;
    }
    .scrollbar {
      margin-bottom: 30px;
    }
  }
`;
